export const SEARCH_PLACEHOLDER = 'Search by page, model, field name or value';

export const SEARCH_MIN_QUERY_LENGTH = 1;
